import axios from './index'
import { cleanParams } from '@/filters'
export const getCaptcha = () => {
  return axios.get('/auth/captcha?key=888', {
    responseType: 'blob',
    emulateJSON: true
  })
}
export const login = (params) => {
  return axios.post('/auth/oauth/token', {
    moveToQuery: true,
    params: cleanParams({ ...params, key: 888, grant_type: 'password' })
  }, {
    headers: {
      Authorization: 'Basic ZmViczoxMjM0NTY='
    }
  })
}
export const switchRole = (params) => {
  return axios.get('/system/role/switchRole', {
    params
  })
}
export const getMyUser = () => {
  return axios.get('/auth/user')
}

// 索引快查，仅支持部分条件
export const getUserByPage = (params) => {
  return axios.get('/system/user', {
    params: cleanParams({ ...params })
  })
}
// 慢查询，支持所有条件，例如指定description字段时需要用此查询
export const getUserByPage2 = params => {
  return axios.get('/system/user/selectList', {
    params: cleanParams({ ...params })
  })
}

export const resetPassword = (usernames) => {
  return axios.put('/system/user/password/reset', {
    moveToQuery: true,
    params: {
      usernames
    }
  })
}

export const addUser = (params) => {
  console.log('请求中')
  delete params.userId
  return axios.post('/system/user', {
    moveToQuery: true,
    params: cleanParams({
      ...params,
      sex: 2,
      deptId: 7,
      deptIds: 7
    })
  })
}
export const updateUser = (params) => {
  return axios({
    method: 'put',
    url: '/system/user',
    data: {
      moveToQuery: true,
      params: {
        ...params,
        sex: 2,
        deptId: 7,
        deptIds: 7
      }
    }
  })
}

export const accountList = (params) => {
  console.log('请求中')
  return axios.get('/system/user/selectList', {
    moveToQuery: true,
    params: cleanParams({
      ...params
    })
  })
}

export const handleUserStatus = (params) => {
  const status = params.status === '1' ? '0' : '1'
  return axios.put('/system/user', {
    moveToQuery: true,
    params: {
      userId: params.userId,
      roleId: params.roleId,
      status,
      sex: 2,
      deptId: 7,
      deptIds: 7
    }
  })
}

export const deleteUser = (id) => {
  return axios.delete(`/system/user/${id}`)
}


export const updateProfile = (params) => {
  return axios({
    method: 'put',
    url: '/system/user/profile',
    data: {
      moveToQuery: true,
      params: {
        ...params,
        sex: '2',
        // deptId: 7,
        deptIds: 7
      }
    }
  })
}

export const updatePassword = (password) => {
  return axios({
    method: 'put',
    url: '/system/user/password',
    data: {
      password: password
    },
    transformRequest: [
      function (data) {
        let ret = ''
        for (const it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.substring(0, ret.lastIndexOf('&'))
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
